import { render, staticRenderFns } from "./NewCardList.vue?vue&type=template&id=d80270e6"
import script from "./NewCardList.vue?vue&type=script&lang=js"
export * from "./NewCardList.vue?vue&type=script&lang=js"
import style0 from "./NewCardList.vue?vue&type=style&index=0&id=d80270e6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports